import React from 'react';
import { Dropdown } from 'react-bootstrap';
import QrCodeScanner from '@mui/icons-material/QrCodeScanner';
import RemoveCircleOutlineOutlined from '@mui/icons-material/RemoveCircleOutlineOutlined';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
import './FinancialActionsMenu.css';
import { JdsMoreToggle } from '../../../../../../components/jds/JdsMoreToggle';

export const FinancialActionsMenu = ({
  isPixPaymentEnabled,
  isPixLoading,
  onPayWithPix,
  isClientAccessControlEnabled,
  isClientAccessBlocked,
  onToggleClientAccess,
  canCancelPlan,
  onCancelPlan,
  onCreateCourtesy,
  isCreateCourtesyDisabled,
}) => (
  <Dropdown alignRight>
    <Dropdown.Toggle
      as={JdsMoreToggle}
      variant="outlined"
      id="financial-actions-toggle"
      aria-label="Mais ações"
    />
    <Dropdown.Menu>
      {isPixPaymentEnabled && (
        <Dropdown.Item onClick={onPayWithPix} disabled={isPixLoading}>
          <QrCodeScanner fontSize="small" className="mr-2" />
          Pagar com Pix
        </Dropdown.Item>
      )}
      {isClientAccessControlEnabled && (
        <Dropdown.Item onClick={onToggleClientAccess}>
          <RemoveCircleOutlineOutlined fontSize="small" className="mr-2" />
          {isClientAccessBlocked ? 'Desbloquear acesso' : 'Bloquear acesso'}
        </Dropdown.Item>
      )}
      <Dropdown.Item
        onClick={onCreateCourtesy}
        disabled={isCreateCourtesyDisabled}
      >
        <DiscountOutlinedIcon fontSize="small" className="mr-2" />
        Criar cortesia
      </Dropdown.Item>
      {canCancelPlan && (
        <Dropdown.Item
          style={{ color: 'var(--fg-error-strong)' }}
          onClick={onCancelPlan}
        >
          <DeleteOutline fontSize="small" className="mr-2" />
          Cancelar plano
        </Dropdown.Item>
      )}
    </Dropdown.Menu>
  </Dropdown>
);
